import React from 'react';
import Image from '../../../components/AppImage';

const MessageBubble = ({ message, isOwnMessage, senderAvatar, senderName }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp)?.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div
      className={`flex gap-3 ${
        isOwnMessage ? 'flex-row-reverse' : 'flex-row'
      }`}
    >
      <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0">
        <Image
          src={senderAvatar}
          alt={`${senderName} profile picture`}
          className="w-full h-full object-cover"
        />
      </div>

      <div
        className={`flex-1 max-w-[70%] ${
          isOwnMessage ? 'items-end' : 'items-start'
        } flex flex-col gap-1`}
      >
        {message?.message_type === 'text' ? (
          <div
            className={`px-4 py-3 rounded-lg ${
              isOwnMessage
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted'
            }`}
          >
            <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">
              {message?.message_text}
            </p>
          </div>
        ) : message?.message_type === 'image' ? (
          <div className="rounded-lg overflow-hidden shadow-warm max-w-sm">
            <Image
              src={message?.image_url}
              alt={message?.image_alt || 'Shared image in conversation'}
              className="w-full h-48 object-cover"
            />
            {message?.message_text && (
              <div className="p-3 bg-muted">
                <p className="text-sm">{message?.message_text}</p>
              </div>
            )}
          </div>
        ) : null}
        <div className="flex items-center gap-2 px-2">
          <span className="text-xs text-muted-foreground">
            {formatTime(message?.created_at)}
          </span>
          {isOwnMessage && message?.is_read && (
            <span className="text-xs text-success">Read</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;